import Vue from 'vue'
import Router from 'vue-router'
import IndexPage from '@/views/Home'
import DownLoadPage from '@/views/DownLoad'
import QuestionsPage from '@/views/Questions/index.vue'
import QuestionsVoucherPage from '@/views/Questions/voucher.vue'
import ExperiencePage from '@/views/Experience/index.vue'
import Apply from '@/views/Experience/apply.vue'
import Explist from '@/views/Experience/explist.vue'
import OldExplist from '@/views/Experience/oldExplist.vue'
import Expdetail from '@/views/Experience/expdetail.vue'
import QuestionsThankPage from '@/views/Questions/thank.vue'
const ErroPage = resolve => require(['@/components/ErroPage'], resolve)

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   redirect: '/experience'
    // },
    {
      path: '/index',
      name: 'IndexPage',
      component: IndexPage
    },
    // 下载页
    {
      path: '/download',
      name: 'DownLoadPage',
      component: DownLoadPage,
      meta: {
        keepAlive: true,
        title: '下载',
        index: 2
      }
    },
    // 问券调查
    {
      path: '/questions',
      name: 'QuestionsPage',
      component: QuestionsPage,
      meta: {
        keepAlive: false,
        title: '问卷登录',
        index: 1
      }
    },
    // 问券调查 答题
    {
      path: '/questionsAnswer',
      name: 'QuestionsAnswerPage',
      component: () => import('@/views/Questions/Answer.vue'),
      meta: {
        keepAlive: false,
        title: '问卷答题',
        index: 2
      }
    },
    // 问券调查 领券
    {
      path: '/questionsVoucher',
      name: 'QuestionsVoucherPage',
      component: QuestionsVoucherPage,
      meta: {
        keepAlive: false,
        title: '问卷领券',
        index: 1
      }
    },
    // 问券调查 感谢参与
    {
      path: '/questionsThank',
      name: 'QuestionsThankPage',
      component: QuestionsThankPage,
      meta: {
        keepAlive: false,
        title: '感谢参与',
        index: 1
      }
    },
    // 体验官招募
    {
      path: '/experience',
      name: 'ExperiencePage',
      component: ExperiencePage,
      meta: {
        keepAlive: true,
        title: '体验官招募令',
        index: 2
      }
    },
    {
      path: '/experienceApply',
      name: 'ExperienceApplyPage',
      component: Apply,
      meta: {
        keepAlive: true,
        title: '体验官招募令',
        index: 2
      }
    },
    {
      path: '/experienceExplist',
      name: 'ExperienceExplistPage',
      component: Explist,
      meta: {
        keepAlive: false,
        title: '体验官招募令',
        index: 2
      }
    },
    {
      path: '/experienceOldExplist',
      name: 'ExperienceOldExplistPage',
      component: OldExplist,
      meta: {
        keepAlive: false,
        title: '体验官招募令',
        index: 2
      }
    },
    {
      path: '/experienceExpdetail',
      name: 'ExperienceExpdetailPage',
      component: Expdetail,
      meta: {
        keepAlive: false,
        title: '体验官招募令',
        index: 2
      }
    },
    {
      path: '/login',
      name: 'laoginPage',
      component: () => import('@/views/Login/index.vue')
    },
    {
      path: '*',
      component: ErroPage,
      meta: {
        keepAlive: true,
        title: '找不到页面',
        index: 1
      }
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js